export enum TypeArticle {
  PLIS = 'Plis',
  COLIS = 'Colis'
}
  